module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@3x-24a7998cf246c237b3a37a15f4641e16.png";